document.addEventListener("DOMContentLoaded", () => {
  let processed = false;
  let attempts = 0;
  const maxAttempts = 10;
  const checkInterval = 200;

  function checkForForm() {
    if (attempts >= maxAttempts) return;

    attempts++;
    const formEm = document.querySelector('shopify-forms-embed');
    if (formEm) {
      callbackFunction();
    } else {
      setTimeout(checkForForm, checkInterval);
    }
  }

  setTimeout(checkForForm, 100);

  function callbackFunction() {
    if (processed) return;

    const formEm = document.querySelector('shopify-forms-embed');
    if (formEm && formEm.shadowRoot) {
      processed = true;

      const styleElement = document.createElement("style");
      styleElement.textContent = `
        :host {
          --inline-container-max-width: 50%;
          --forms-heading-font-size: 40px;
          --forms-heading-font: normal 700 40px MuseoSans, sans-serif;
          --form-heading-margin-bottom: 48px;
          --container-text-alignment: center;
          --forms-body-font: normal 500 16px MuseoSans, sans-serif;
        }

        @media (max-width: 768px) {
          :host {
            --forms-heading-font: normal 700 32px MuseoSans, sans-serif;
            --form-heading-margin-bottom: 24px;
            --inline-container-max-width: 98%;
          }
        }

        h2 {
          line-height: 1.2 !important;
          margin-bottom: var(--form-heading-margin-bottom) !important;
          font-family: MuseoSans, sans-serif !important;
          font-weight: 700 !important;
        }

        p {
          font-family: MuseoSans, sans-serif !important;
          font-weight: 400 !important;
        }

        input, textarea, select {
          font-family: MuseoSans, sans-serif !important;
          font-weight: 500 !important;
        }

        button, input[type="submit"] {
          font-family: MuseoSans, sans-serif !important;
          font-weight: 700 !important;
        }

        label {
          font-family: MuseoSans, sans-serif !important;
          font-weight: 500 !important;

        }

        [class*="_checkboxFieldSet"] legend {
          display: none;
        }

        form {
          gap: 0 !important;
          row-gap: 15px !important;
        }
      `;

      formEm.shadowRoot.appendChild(styleElement);

      // Apply form-specific styles
      const formContainer = formEm.closest('#shopify-block-ASWlsUGxMb3NDdHgvT__forms_inline_c6p3Cc');
      if (formContainer) {
        const specificStyleElement = document.createElement("style");
        specificStyleElement.textContent = `
          label {
            font-size: 14px !important;
            letter-spacing: normal;
          }

          @media (max-width: 768px) {
            label {
              font-size: 11px !important;
            }
          }
        `;
        formEm.shadowRoot.appendChild(specificStyleElement);
      }

      // Auto-check first checkbox if exists
      const firstCheckbox = formEm.shadowRoot.querySelector('[type="checkbox"]');
      if (firstCheckbox) {
        firstCheckbox.checked = true;
      }
    } else if (!processed) {
      setTimeout(callbackFunction, 500);
    }
  }
});